import { Link } from "react-router-dom";
import { blogArticles } from "@/mocks/blogArticles";

export default function BlogCTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300/60 text-xs font-label text-foreground-600 tracking-wider uppercase whitespace-nowrap">
            SEO Articles & Guides
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-foreground-950">
            Master the <span className="italic">itaobuyspreadsheet</span><br />
            with Expert Articles
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 font-label max-w-[560px] mx-auto">
            In-depth guides, honest reviews, and pro tips to help you get the most out of your structured shopping experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {blogArticles.map((article) => (
            <Link
              key={article.id}
              to={`/blog/${article.id}`}
              className="group flex flex-col bg-background-50 rounded-lg border border-background-200/60 hover:border-secondary-300/50 transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3">
                  <span className="inline-block px-3 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-[10px] md:text-xs font-label text-foreground-700 font-medium whitespace-nowrap">
                    {article.readTime}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-5 md:p-6">
                <span className="text-xs text-foreground-500 font-label mb-2">{article.date}</span>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed font-label line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center text-sm font-label font-medium text-primary-600">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line ml-1.5 group-hover:ml-2 transition-all"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/blog/itaobuyspreadsheet-guide"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-primary-500 text-background-50 font-label font-medium text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span>Read the Complete Shopping Guide</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}